// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"347202a5","183":"47094d3d"}[chunkId] + ".chunk.js";
};